import { captureException } from '@sentry/react'
import { FirebaseError } from 'firebase/app'

// The user closed the popup or opened a second one. Nothing to fix.
const IGNORED_ERROR_CODES = [
  'auth/popup-closed-by-user',
  'auth/cancelled-popup-request',
]

export function captureLoginError(
  error: unknown,
  {
    authProvider,
    providerId,
    authStage,
  }: {
    authProvider: 'google' | 'microsoft' | 'password'
    providerId: string
    authStage:
      | 'sign_in_with_popup'
      | 'sign_in_with_existing_provider_popup'
      | 'link_with_popup'
      | 'sign_in_with_password'
  }
) {
  if (!(error instanceof FirebaseError)) return
  if (IGNORED_ERROR_CODES.includes(error.code)) return

  captureException(error, {
    tags: {
      feature: 'login',
      auth_provider: authProvider,
      firebase_error_code: error.code,
      auth_stage: authStage,
    },
    contexts: {
      firebase_auth: {
        code: error.code,
        provider: providerId,
        // Only the key names: the values can hold the email address, OAuth
        // access and ID tokens, and _tokenResponse.
        customDataKeys: Object.keys(error.customData ?? {}),
      },
    },
    fingerprint: ['firebase-login', authProvider, error.code],
  })
}
